import type { Room, User } from "@/lib/types";

export interface SearchFilterState {
  roomIds: string[];
  authorIds: string[];
  after: string;
  before: string;
  hasFile: boolean;
}

export function SearchFiltersForm({
  rooms,
  authors,
  value,
  onChange,
}: {
  rooms: Room[];
  authors: User[];
  value: SearchFilterState;
  onChange: (next: SearchFilterState) => void;
}): JSX.Element {
  return (
    <fieldset className="grid gap-3 md:grid-cols-2 xl:grid-cols-4 text-sm">
      <legend className="sr-only">検索条件</legend>
      <label className="flex flex-col gap-1">
        <span className="text-xs text-fg-muted">ルーム（複数可）</span>
        <select
          multiple
          aria-label="検索対象ルーム"
          className="min-h-24 rounded-md border border-border-default bg-canvas px-2 py-1"
          value={value.roomIds}
          onChange={(event) => onChange({ ...value, roomIds: Array.from(event.target.selectedOptions).map((option) => option.value) })}
        >
          {rooms.map((room) => (
            <option key={room.id} value={room.id}>{room.name}</option>
          ))}
        </select>
        {value.roomIds.length > 0 ? (
          <button type="button" className="text-xs text-brand-700 underline self-start" onClick={() => onChange({ ...value, roomIds: [] })}>
            ルーム指定を解除
          </button>
        ) : null}
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-xs text-fg-muted">投稿者（複数可）</span>
        <select
          multiple
          aria-label="投稿者"
          className="min-h-24 rounded-md border border-border-default bg-canvas px-2 py-1"
          value={value.authorIds}
          onChange={(event) => onChange({ ...value, authorIds: Array.from(event.target.selectedOptions).map((option) => option.value) })}
        >
          {authors.map((author) => (
            <option key={author.id} value={author.id}>{author.displayName}</option>
          ))}
        </select>
        {authors.length === 0 ? <span className="text-xs text-fg-muted">ルームを選ぶと投稿者が表示されます。</span> : null}
      </label>
      <div className="flex flex-col gap-2">
        <label className="flex flex-col gap-1">
          <span className="text-xs text-fg-muted">この日以降</span>
          <input type="date" aria-label="開始日" className="h-10 rounded-md border border-border-default bg-canvas px-3" value={value.after} onChange={(event) => onChange({ ...value, after: event.target.value })} />
        </label>
        <label className="flex flex-col gap-1">
          <span className="text-xs text-fg-muted">この日より前</span>
          <input type="date" aria-label="終了日" className="h-10 rounded-md border border-border-default bg-canvas px-3" value={value.before} onChange={(event) => onChange({ ...value, before: event.target.value })} />
        </label>
      </div>
      <label className="flex items-center gap-2 mt-6">
        <input type="checkbox" aria-label="添付あり" checked={value.hasFile} onChange={(event) => onChange({ ...value, hasFile: event.target.checked })} />
        <span>添付ファイルあり</span>
      </label>
      <p className="md:col-span-2 xl:col-span-4 text-xs text-fg-muted">
        キーワードに <code>from:</code> <code>in:</code> <code>before:</code> <code>after:</code> <code>has:file</code> も使えます。
      </p>
    </fieldset>
  );
}
